import { render, staticRenderFns } from "./UserListHeaderItem.vue?vue&type=template&id=794c68fc&scoped=true&"
import script from "./UserListHeaderItem.vue?vue&type=script&lang=js&"
export * from "./UserListHeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./UserListHeaderItem.vue?vue&type=style&index=0&id=794c68fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c68fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
